module.exports = __webpack_public_path__ + "img/welfare_img2.43296869.svg";